import React, { useEffect, useState } from "react";
import { useStorage } from "../../hooks/useLocalStorage";
import { getData, postData } from "../../api/api";
import { Pagination, Modal } from "antd";
import { useNotification } from "../../Notification/Notification";

export default function TabsOrderHistory() {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [user] = useStorage("use", null);
  const [transactions, setTransactions] = useState([]);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const { notificationApi } = useNotification();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);

  useEffect(() => {
    getData(`/payments/${user.id}/payment`)
      .then((response) => {
        setTransactions(response?.data?.data || []);
        console.log("Transactions fetched:", response);
      })
      .catch((error) => {
        console.error("Error fetching transactions:", error);
      });
  }, [user]);

  // Reset currentPage when searchTerm or statusFilter changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, statusFilter]);

  const filteredTransactions = transactions.filter(
    (transaction) =>
      transaction.retreatName
        .toLowerCase()
        .includes(searchTerm.toLowerCase()) &&
      (statusFilter === "All" || transaction.status === statusFilter)
  );

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const paginatedTransactions = filteredTransactions.slice(
    startIndex,
    endIndex
  );

  const getStatusColor = (status) => {
    switch (status) {
      case "Success":
        return "text-green-600";
      case "Processing":
        return "text-blue-600";
      case "Refunded":
        return "text-red-600";
      case "Cancel":
        return "text-red-600";
        

      default:
        return "text-gray-600";
    }
  };

  const payContinue = () => {
    setIsSubmitting(true);

    postData(`/payments`, {
      retreatRegId: selectedTransaction?.retreatRegId,
    })
      .then((e) => {
        window.location.href = e.paymentUrl;
        setIsSubmitting(false);
      })
      .catch((error) => {
        console.log(error);
        setErrorMessages(error?.data?.messages || ["Payment error"]);
        notificationApi("error", "Payment error", "Payment error");
        setIsSubmitting(false);
      });
  };

  const handleErrorModal = () => {
    if (errorMessages.length > 0) {
      Modal.error({
        title: 'Error',
        content: (
          <div>
            {errorMessages.map((msg, index) => (
              <p key={index}>{msg}</p>
            ))}
          </div>
        ),
        onOk() {
          setErrorMessages([]); // Clear messages after modal is closed
        },
      });
    }
  };

  useEffect(() => {
    handleErrorModal(); // Show error modal if there are error messages
  }, [errorMessages]);

  return (
    <div className="">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">Transaction History</h1>

        <div className="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between">
          <div className="relative mb-4 sm:mb-0">
            <input
              type="text"
              placeholder="Search retreat..."
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <svg
              className="w-5 h-5 text-gray-500 absolute left-3 top-1/2 transform -translate-y-1/2"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </div>
          <select
            className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option>All</option>
            <option>Success</option>
            <option>Pending</option>
            <option>Cancel</option>
            <option>Refunded</option>
          </select>
        </div>

        <div className="space-y-4">
          {paginatedTransactions.map((transaction) => (
            <div
              key={transaction.id}
              className="bg-white rounded-lg shadow-md overflow-hidden flex flex-col sm:flex-row cursor-pointer"
              onClick={() => setSelectedTransaction(transaction)}
            >
              <div className="p-4 flex-grow flex flex-col justify-between">
                <div>
                  <h3 className="font-bold text-lg mb-2">
                    {transaction.retreatName}
                  </h3>
                  <p className="text-sm text-gray-600">
                    Transaction Date:{" "}
                    {new Date(transaction.createAt).toLocaleDateString()}
                  </p>
                </div>
                <div className="flex justify-between items-center mt-4">
                  <span className="text-lg font-semibold">
          
                  ${transaction.status === "Refunded" ? (transaction.amount * 0.8).toLocaleString() : transaction.amount.toLocaleString()}
                  </span>
                  <span
                    className={`px-3 py-1 rounded-full text-sm font-semibold ${getStatusColor(
                      transaction.status
                    )}`}
                  >
                    {transaction.status}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredTransactions.length === 0 && (
          <p className="text-center text-gray-500 mt-6">
            No transactions found.
          </p>
        )}

        {/* Thêm Pagination */}
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={filteredTransactions.length}
            onChange={(page) => setCurrentPage(page)}
          />
        </div>
      </div>

      {/* Modal for Transaction Details */}
      {selectedTransaction && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50 p-2">
          <div className="bg-white p-6 rounded-lg w-[98%] max-w-[1400px] max-h-[95vh] overflow-y-auto relative">
            <h2 className="text-2xl font-bold mb-6">Transaction Details</h2>
            
            {/* Transaction Info - Simple Layout */}
            <div className="mb-6">
              <p className="mb-2">
                <strong>Retreat Name:</strong> {selectedTransaction.retreatName}
              </p>
              <p className="mb-2">
                <strong>Amount:</strong> ${selectedTransaction.status === "Refunded" ? (selectedTransaction.amount * 0.8).toLocaleString() : selectedTransaction.amount.toLocaleString()}
              </p>
              <p className="mb-2">
                <strong>Date:</strong> {new Date(selectedTransaction.createAt).toLocaleString()}
              </p>
              <p className="mb-2">
                <strong>Status:</strong> {selectedTransaction.status}
              </p>
              <p className="mb-2">
                <strong>Total Participants:</strong> {selectedTransaction.retreatReg.totalParticipants}
              </p>
            </div>

            <h3 className="text-xl font-bold mt-6 mb-4">
            Participants
            </h3>
            <div className="overflow-x-auto">
              <table className="w-full border-collapse border border-gray-300 min-w-[800px]">
                {selectedTransaction.status === "Refunded" ? (
                  // Table for Refunded status - Show user information
                  <>
                    <thead>
                      <tr className="bg-gray-50">
                      <th className="border border-gray-300 p-3 text-left">First Name</th>
                        <th className="border border-gray-300 p-3 text-left">Last Name</th>
                        <th className="border border-gray-300 p-3 text-left">Email</th>
                        <th className="border border-gray-300 p-3 text-left">Phone</th>
                        <th className="border border-gray-300 p-3 text-left">Gender</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="hover:bg-gray-50">
                        <td className="border border-gray-300 p-3">
                          {user.firstName} 
                        </td>
                        <td className="border border-gray-300 p-3">
                             {user.lastName}
                        </td>
                        <td className="border border-gray-300 p-3">
                          {user.email}
                        </td>
                        <td className="border border-gray-300 p-3">
                          {user.phoneNumber || 'N/A'}
                        </td>
                        <td className="border border-gray-300 p-3">
                          {user.gender || 'N/A'}
                        </td>
                      </tr>
                    </tbody>
                  </>
                ) : (
                  // Table for other statuses - Show participants information
                  <>
                    <thead>
                      <tr className="bg-gray-50">
                        <th className="border border-gray-300 p-3 text-left">First Name</th>
                        <th className="border border-gray-300 p-3 text-left">Last Name</th>
                        <th className="border border-gray-300 p-3 text-left">Email</th>
                        <th className="border border-gray-300 p-3 text-left">Phone</th>
                        <th className="border border-gray-300 p-3 text-left">Gender</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedTransaction.retreatReg.retreatRegistrationParticipants.map(
                        (participantObj) => (
                          <tr key={participantObj.id} className="hover:bg-gray-50">
                            <td className="border border-gray-300 p-3">
                              {participantObj.participant.firstName}
                            </td>
                            <td className="border border-gray-300 p-3">
                              {participantObj.participant.lastName}
                            </td>
                            <td className="border border-gray-300 p-3">
                              {participantObj.participant.email}
                            </td>
                            <td className="border border-gray-300 p-3">
                              {participantObj.participant.phoneNumber || 'N/A'}
                            </td>
                            <td className="border border-gray-300 p-3">
                              {participantObj.participant.gender}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </>
                )}
              </table>
            </div>

            <div className="flex justify-between mt-6">
              <button
                className={`px-6 py-2 ${
                  isSubmitting
                    ? "bg-gray-400"
                    : "bg-yellow-500 hover:bg-yellow-600"
                } text-white rounded-lg`}
                disabled={isSubmitting}
                onClick={() => setSelectedTransaction(null)}
              >
                Close
              </button>

              {selectedTransaction.status === "Pending" && (
                <button
                  className={`px-6 py-2 ${
                    isSubmitting
                      ? "bg-gray-400"
                      : "bg-blue-500 hover:bg-blue-600"
                  } text-white rounded-lg`}
                  disabled={isSubmitting}
                  onClick={() => payContinue(null)}
                >
                  {isSubmitting ? "Please wait..." : "Continue payment"}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
